import API from '@aws-amplify/api';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import './OutputPreview.scss';

export default function OutputPreview(props) {
    const question = props.question;
    const appInstanceId = props.appInstanceId;
    const shouldShowErrors = props.shouldShowErrors;
    const disabled = props.disabled;

    const [t] = useTranslation();
    const [previewURL, setPreviewURL] = useState();
    const [clicked, setClicked] = useState(false);
    const [templateId] = useState(question?.reservedAttributeEnumID);
    const [generating, setGenerating] = useState(false);
    const anchorRef = useRef();

    useEffect(() => {
        if (clicked) {
            setClicked(false);
            setGenerating(true);

            const getPreview = async () => {
                try {
                    const response = await API.get('ShipyardAPI', `/application/docs/preview/${templateId}`, {
                        queryStringParameters: {
                            appInstId: appInstanceId,
                        },
                    });

                    setPreviewURL(response.previewURL);
                } catch (e) {
                    toast.error(t('General.AjaxError'));

                    setGenerating(false);
                }
            };

            getPreview();
        }
    }, [clicked, templateId, appInstanceId, t]);

    useEffect(() => {
        if (!!previewURL) {
            anchorRef.current.click();
            setPreviewURL();
            setGenerating(false);
        }
    }, [previewURL]);

    return (
        <div
            className={
                'question-wrapper output-preview' +
                (!question.isValid && shouldShowErrors ? ' invalid' : '') +
                (disabled ? ' disabled' : '')
            }
        >
            <div className="link-button-container">
                <div
                    className={!generating ? 'link-button' : ['link-button', 'disabled'].join(' ')}
                    onClick={
                        !generating
                            ? () => {
                                  setClicked(true);
                              }
                            : null
                    }
                >
                    ({t('OutputPreview.AnchorText')})
                </div>
                {generating ? (
                    <div className="generating">
                        <FontAwesomeIcon icon={faSpinner} />
                    </div>
                ) : null}
            </div>
            <a
                target="_blank"
                rel="noreferrer"
                href={previewURL}
                className="hidden"
                ref={anchorRef}
            >
                {' '}
            </a>
        </div>
    );
}
